export default __webpack_public_path__ + "static/media/Harness of Jagged Barbs.595a34c3.jpg";